































import BaseComponent from '@/components/base-component.vue';
import ParametersEditModal from '@/components/parameters/edit-modal.vue';
import UiInputFile from '@/components/UI/input-file.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ParameterModel from '@/models/parameter-model';
import { saveFileParameter } from '@/services/parameters';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ParametersEditModal,
    UiInputFile,
  },
})
export default class ParametersFormFileType extends BaseComponent {
  @Prop()
  public editItem: any;
  @Prop()
  public modalOpen: boolean;

  public item: ParameterModel = new ParameterModel();

  file: any = null;

  public rules: any = {
    file: [(val) => val || 'Selecione um arquivo'],
  };

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = new ParameterModel();

    if (!val) {
      return;
    }

    this.item = new ParameterModel(this.editItem);
  }

  public beforeMount(): void {
    this.onEditItemChanges(this.editItem);
  }

  public onClose(): void {
    this.$emit('close');
  }

  getOriginalFileName() {
    if (this.file && this.file.name) {
      return this.file.name;
    }
    if (this.item && this.item.valores[0].valor) {
      let v = String(this.item.valores[0].valor);
      return v.substring(v.lastIndexOf('/') + 1);
    }
    return null;
  }

  getUrlDownloadFile() {
    if (this.item && this.item.valores[0].valor) {
      return this.item.valores[0].valor;
    }
    return null;
  }

  onDeletePdf() {
    this.item.valores[0].valor = null;
  }

  onChangeFile(file) {
    if (!file) {
      return;
    }
    this.loader.start('Salvando arquivo...');
    saveFileParameter(this.file).subscribe(
      (res) => {
        this.item.valores[0].valor = res.url;
        this.loader.stop();
      },
      (error) => {
        this.showToastApiError(error);
        this.loader.stop();
      },
    );
  }
}
